import {
  BODY_FONT,
  DATA_START_ROW,
  HEADER_FONT_11,
  HEADER_FONT_12,
  NA_FILL,
  VALUE_FILL,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  COL_K,
  addHiddenTemplateRow,
  addPrinciple2BackLink,
  addSheetTitle,
  addSimpleTableHeader,
  addTableSpacer,
  displayText,
  formatPercent,
  setupPrinciple2DetailSheet,
  toYesNo,
  writeDataRow,
  hideRowsThrough,
} from "./principle2DetailHelpers.js";

const SHEET_TITLE =
  "The entity conducted Life Cycle Perspective/Assessments (LCA)";

export const SHEET_NAME = "Life cycle assessment";

const WIDTHS = {
  A: 9.1796875,
  B: 9.1796875,
  C: 9.1796875,
  D: 9.1796875,
  E: 14,
  F: 28.54296875,
  G: 27.453125,
  H: 31.54296875,
  I: 26.26953125,
  J: 34.81640625,
  K: 34.81640625,
  L: 9.1796875,
  M: 9.1796875,
  N: 9.1796875,
};

const HEADERS = [
  { col: COL_D, label: "Sr. No.", font: HEADER_FONT_11 },
  { col: COL_E, label: "NIC Code", font: HEADER_FONT_12 },
  { col: COL_F, label: "Name of Product/Service", font: HEADER_FONT_12 },
  { col: COL_G, label: "% of total Turnover contributed", font: HEADER_FONT_12 },
  {
    col: COL_H,
    label: "Boundary for which the Life Cycle Perspective/Assessment was conducted",
    font: HEADER_FONT_11,
  },
  {
    col: COL_I,
    label: "Whether conducted by independent external agency (Yes/No)",
    font: HEADER_FONT_11,
  },
  {
    col: COL_J,
    label: "Results communicated in public domain (Yes/No)",
    font: HEADER_FONT_11,
  },
  { col: COL_K, label: "If yes, provide the web-link.", font: HEADER_FONT_11 },
];

export function buildLifeCycleAssessmentSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: false }] });
  const colEnd = COL_K;

  setupPrinciple2DetailSheet(ws, {
    widths: WIDTHS,
    colEnd,
    lastVisibleCol: 14,
    xSplit: 3,
  });
  addPrinciple2BackLink(ws, colEnd);

  addSheetTitle(ws, colEnd, SHEET_TITLE);
  addSimpleTableHeader(ws, COL_D, colEnd, HEADERS, { height: 43.5 });
  addHiddenTemplateRow(ws, COL_D, colEnd, { height: 15.5, naCols: [COL_K] });
  addTableSpacer(ws, COL_D, colEnd);

  const rows = Array.isArray(
    sectionC?.principle2?.leadershipIndicator?.lifeCycleAssessments?.assessments
  )
    ? sectionC.principle2.leadershipIndicator.lifeCycleAssessments.assessments
    : [];
  const dataRows = rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    writeDataRow(ws, row, COL_D, colEnd, [
      { col: COL_D, value: String(idx + 1), align: "center", fill: undefined, font: BODY_FONT },
      { col: COL_E, value: displayText(item?.nicCode), align: "left" },
      { col: COL_F, value: displayText(item?.productName), align: "left" },
      { col: COL_G, value: formatPercent(item?.percentageOfTurnover), align: "center" },
      { col: COL_H, value: displayText(item?.boundary), align: "left", vertical: "top" },
      { col: COL_I, value: toYesNo(item?.conductedByExternalAgency), align: "center" },
      { col: COL_J, value: toYesNo(item?.resultsPublicDomain), align: "center" },
      { col: COL_K, value: displayText(item?.webLink), align: "left", fill: NA_FILL },
    ]);
    ws.getRow(row).height = 15.5;
  });

  hideRowsThrough(ws, 5);
  return ws;
}
